import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { EntityListAction, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { HrmLoanToPersonnel } from "../../models/hrm-loan-to-personnel.model";
import { HrmLoanDeductFormComponent } from "../hrm-loan-deduct-form/hrm-loan-deduct-form.component";
import { HrmLoanEditFormComponent } from "../hrm-loan-edit-form/hrm-loan-edit-form.component";
import { HrmLoanToPersonnelFormComponent } from "../hrm-loan-to-personnel-form/hrm-loan-to-personnel-form.component";

@Component({
  selector: "ngx-hrm-loan-to-personnel-list",
  templateUrl: "./hrm-loan-to-personnel-list.component.html",
  styleUrls: ["./hrm-loan-to-personnel-list.component.scss"],
})
export class HrmLoanToPersonnelListComponent extends BaseListComponent {
  loadingIndicator: boolean;
  inputEditorform: any;
  editingName: { name: string };
  actions: EntityListAction[];
  constructor(private tabsservice: TabularService) {
    super();
    this.inputEditorform = HrmLoanToPersonnelFormComponent;
    this.onActionClick = this.onActionClick.bind(this);
  }
  ngOnInit() {
    this.apiName = "HrmLoanToPersonnel";
    this.areaName = "Payroll";
    this.label = "وام کارکنان";
    this.setactions();
  }
  onActionClick(
    action: EntityListAction,
    onRowSelected: HrmLoanToPersonnel,
    onRowsSelected: HrmLoanToPersonnel[],
    isAllSelected: boolean,
    gridFilter: GridFilter[]
  ) {
    let inputEditorform2: any;
    if (!onRowSelected) this.sts.showDialog("هیچ وامی انتخاب نشده است", "وام کارکنان");
    ///تسویه وام
    if (action.name === "HrmLoanDeduct" && onRowSelected) {
      inputEditorform2 = HrmLoanDeductFormComponent;
      this.dialogService
        .open(
          inputEditorform2,
          {
            currentrow: onRowSelected,
            apiName: this.apiName,
            areaName: this.areaName,
            label: this.label,
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
            closeOnEscape: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model) => {
          this.tabsservice.tabItemonRefreshData.next(this.apiName);
        });
    }
    ///تعدیل وام
    if (action.name === "HrmLoanEdit" && onRowSelected) {
      inputEditorform2 = HrmLoanEditFormComponent;
      this.dialogService
        .open(
          inputEditorform2,
          {
            currentrow: onRowSelected,
            apiName: this.apiName,
            areaName: this.areaName,
            label: this.label,
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
            closeOnEscape: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model) => {
          this.tabsservice.tabItemonRefreshData.next(this.apiName);
        });
    }
  }
  setactions() {
    this.actions = [
      {
        name: "HrmLoanDeduct",
        disabled: false,
        displayName: "تسویه وام",
        iconName: "icon-payments-o",
        apiName: "HrmLoanToPersonnel/HrmLoanDeduct",
        areaName: "Payroll",
        isModal: true,
        permission: Permission.samePermission,
      },
      {
        name: "HrmLoanEdit",
        disabled: false,
        displayName: "تعدیل وام",
        iconName: "icon-playlist-edit",
        apiName: "HrmLoanToPersonnel/HrmLoanEdit",
        areaName: "Payroll",
        isModal: true,
        permission: Permission.samePermission,
      },
    ];
  }
}
